import { trigger, transition, query, style, animate } from '@angular/animations';
import * as BezierEasing_ from 'bezier-easing';

const siRouterFadeAnimation = trigger('siRouterFadeAnimation', [
    transition('*=>*', [
        query(':enter section, :enter [si-router-animate]', [
            style({ position: 'absolute', top: '-9999999px' }),
        ], { optional: true }),
        // For landing page: if image is visible during animation opacity effect is broken
        query('section div.image', [
            style({ position: 'absolute', top: '-9999999px' }),
        ], { optional: true }),
        query(':leave section, :leave [si-router-animate]', [
            style({ opacity: 1 }),
            animate('0.2s ease-in', style({ opacity: 0 })),
            style({ position: 'absolute', top: '-9999999px' }),
        ], { optional: true }),
        query(':enter section, :enter [si-router-animate]', [
            style({ position: 'initial', opacity: 0 }),
            animate('0.2s ease-out', style({ opacity: 1 })),
        ], { optional: true }),
    ]),
]);

const siLinearEasing = 'cubic-bezier(0.00, 0.00, 1.00, 1.00)';
const siSnappyEasing = 'cubic-bezier(0.12, 0.00, 0.50, 1.00)';
const siFluidEasing = 'cubic-bezier(0.66, 0.00, 0.10, 1.00)';
// workaround webpack/TS problem
const BezierEasing = BezierEasing_.default;
const siLinearEasingFunction = BezierEasing(0.00, 0.00, 1.00, 1.00);
const siSnappyEasingFunction = BezierEasing(0.12, 0.00, 0.50, 1.00);
const siFluidEasingFunction = BezierEasing(0.66, 0.00, 0.10, 1.00);

/**
 * Generated bundle index. Do not edit.
 */

export { siFluidEasing, siFluidEasingFunction, siLinearEasing, siLinearEasingFunction, siRouterFadeAnimation, siSnappyEasing, siSnappyEasingFunction };
